import { all, fork } from 'redux-saga/effects';

import locationsSaga from './sagas/locationsSaga';
import userActivitySaga from './sagas/userActivitySaga';
import usersSaga from './sagas/usersSaga';
import visitorInvitationSaga from './sagas/visitorInvitationSaga';
import visitorSearchSaga from './sagas/visitorSearchSaga';
import visitorsSaga from './sagas/visitorsSaga';
import visitorTypesSaga from './sagas/visitorTypesSaga';
import visitorWorkflowsSaga from './sagas/visitorWorkflowsSaga';
import visitsSaga from './sagas/visitsSaga';
import agreementsSaga from './sagas/agreementsSaga';
import customFieldsSaga from './sagas/customFieldsSaga';
import emailTemplatesSaga from './sagas/emailTemplatesSaga';
import kiosksSaga from './sagas/kiosksSaga';
import altaVideoSaga from './sagas/altaVideoSaga';
import { denySaga } from './sagas/denySaga';
import integrationSaga from './sagas/integrationSaga';
import redFlagSaga from './sagas/redFlagSaga';

export default function* rootSaga() {
  yield all([
    fork(locationsSaga),
    fork(userActivitySaga),
    fork(usersSaga),
    fork(visitorInvitationSaga),
    fork(visitorSearchSaga),
    fork(visitorsSaga),
    fork(visitorTypesSaga),
    fork(visitorWorkflowsSaga),
    fork(visitsSaga),
    fork(agreementsSaga),
    fork(customFieldsSaga),
    fork(emailTemplatesSaga),
    fork(kiosksSaga),
    fork(altaVideoSaga),
    fork(denySaga),
    fork(integrationSaga),
    fork(redFlagSaga),
  ]);
}
